import { styled, IconButton } from '@mui/material';

export const IconBtn = styled(IconButton)`
    height: 40px;
    background: #e8f4ff;
    border-radius: 12px;
`;
